import React, { Fragment } from 'react';
import PropTypes, { object } from 'prop-types';
import { useTranslation } from 'react-i18next';

import Account from '../Account/Account';
import {
  DateTime,
  HealthPoint,
  Member,
  Table,
  TableCell
} from 'components/common/Elements/Elements';

import { moneyFormater } from 'utils/common';

import classes from './RolloutCustomersTable.module.scss';
import { access, hasAccess, resources } from 'utils/permissions';

const TableRow = ({
  company,
  tableConf,
  row,
  mouseEnter,
  handleCheckCustomer,
  isSelectedCustomer,
  CheckBox
}) => {
  const { t } = useTranslation(['activity']);

  const createMember = user => {
    return {
      fullName: user,
      initials: user
        .split(' ')
        .map(x => x.charAt(0))
        .join('')
        .substr(0, 2)
        .toUpperCase()
    };
  };

  const hasAgentRolloutWriteAccess = hasAccess([
    resources.CS_AGENT_ROLLOUT,
    access.WRITE
  ]);

  return (
    <Table.Row className={classes.row}>
      {tableConf.map(({ show, field }, ind) => {
        const cellProps = {
          row: row,
          mouseEnter: mouseEnter,
          ind: ind,
          field: field,
          classes: classes
        };

        return (
          <Fragment key={`${field}-${company.email}}`}>
            {show && field === 'companyName' && (
              <TableCell cellProps={cellProps}>
                <CheckBox
                  company={company}
                  handleCheck={handleCheckCustomer}
                  isSelected={isSelectedCustomer(company.customerId)}
                  disabled={!hasAgentRolloutWriteAccess}
                />
                <Account data={company} />
              </TableCell>
            )}
            {show && field === 'plan' && (
              <TableCell cellProps={cellProps}>{company.plan}</TableCell>
            )}
            {show && field === 'arr' && (
              <TableCell cellProps={cellProps}>
                {' '}
                {moneyFormater(company.arr)}
              </TableCell>
            )}

            {show && field === 'accountManager' && (
              <TableCell cellProps={cellProps}>
                {company.accountManager !==
                t('activity:customers:UNASSIGNED') ? (
                  <Member member={createMember(company.accountManager)} />
                ) : (
                  t('activity:customers:UNASSIGNED')
                )}
              </TableCell>
            )}
            {show && field === 'customerSuccessEngineer' && (
              <TableCell cellProps={cellProps}>
                {company.customerSuccessEngineer !==
                t('activity:customers:UNASSIGNED') ? (
                  <Member
                    member={createMember(company.customerSuccessEngineer)}
                  />
                ) : (
                  t('activity:customers:UNASSIGNED')
                )}
              </TableCell>
            )}
            {show && field === 'billingCycle' && (
              <TableCell cellProps={cellProps}>
                {company.billingCycle}
              </TableCell>
            )}
            {show && field === 'firstPaymentDate' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.firstPaymentDate} />
              </TableCell>
            )}
            {show && field === 'nextBillingDate' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.nextBillingDate} />
              </TableCell>
            )}
            {show && field === 'firstInvoiceAt' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.firstInvoiceAt} />
              </TableCell>
            )}
            {show && field === 'healthStatus' && (
              <TableCell cellProps={cellProps}>
                <HealthPoint
                  data={{
                    point: company.healthPoint,
                    status: company.healthStatus
                  }}
                />
              </TableCell>
            )}
          </Fragment>
        );
      })}
    </Table.Row>
  );
};

TableRow.propTypes = {
  company: PropTypes.object,
  tableConf: PropTypes.arrayOf(object),
  row: PropTypes.string,
  mouseEnter: PropTypes.func,
  handleCheckCustomer: PropTypes.func,
  isSelectedCustomer: PropTypes.func,
  CheckBox: PropTypes.func
};

export default TableRow;
